import { useEffect, useState } from "react"
import { useAppDispatch, useAppSelector } from "../../../../lib/redux/hooks"
import { SelectCustom } from "../../../../ui/molecules/select"
import { OptionType } from "../../../../utils";
import { PrinterIcon } from "../../../../ui/icons/PrinterIcon";
import Button from "../../../../ui/molecules/button";
import { TaskSquare } from "../../../../ui/icons/TaskSquare";
import { CustomHorizontalTab } from "../../../../ui/organisms/customHorizontalTab";
import { ComparazioneVegetale } from "./vegetale";
import { GetComparison, resetGetCompareStatus, setCurrentNotId, setCurrentNotStatusId, setNotStatusOfficerId, setPrevNotId, setSaveStatusParticelleAlienate, setSaveStatusParticelleInserite, setSaveStatusStruttureAlienate, setSaveStatusStruttureInserite } from "./slice";
import { ComparazioneZootecnia } from "./zootecnia";
import { LogoSpinnerComponent } from "../../../../lib/spinner/spinnerLogo";
import { ComparazionePreparazione } from "./preparazione";

export function ComparazioneNotifiche() {
    const dispatch = useAppDispatch()
    const notificationState = useAppSelector(state => state.notification)
    const notificationStatusState = useAppSelector(state => state.notificationStatus)
    const selectedNot = notificationState.notificationIdToUpdate;
    const selectedStatusNot = notificationStatusState.notificationStatusIdToUpdate;
    const comparisonState = useAppSelector(state => state.NotComparison)
    const [selectedTab, setSelectedTab] = useState<number>(0)
    const [showContent, setShowContent] = useState<boolean>(false)
    const userState = useAppSelector(state => state.users)

    useEffect(() => {
        setShowContent(false)
        dispatch(setCurrentNotId(selectedNot))
        dispatch(setCurrentNotStatusId(selectedStatusNot))
        dispatch(setNotStatusOfficerId(userState.findMeResponse.id))
    }, [])

    useEffect(() => {
        if (comparisonState.GetComparisonResponsestatus === 'successfully') {
            setShowContent(true)
            let alienatedString = ''
            let insertedString = ''
            if (comparisonState.GetComparisonResponse && comparisonState.GetComparisonResponse.alienatedParcelComparisons) {
                comparisonState.GetComparisonResponse.alienatedParcelComparisons.map((alienatedParcel) =>
                    alienatedString = alienatedString + " " + alienatedParcel.sheet + "-" + alienatedParcel.parcel + ";"
                )
                dispatch(setSaveStatusParticelleAlienate(alienatedString))
            }
            if (comparisonState.GetComparisonResponse && comparisonState.GetComparisonResponse.insertedParcelComparisons) {
                comparisonState.GetComparisonResponse.insertedParcelComparisons.map((insertedParcel) =>
                    insertedString = insertedString + " " + insertedParcel.sheet + "-" + insertedParcel.parcel + ";"
                )
                dispatch(setSaveStatusParticelleInserite(insertedString))
            }


            dispatch(resetGetCompareStatus())
        }
    }, [comparisonState.GetComparisonResponsestatus])

    //stato strutture 

    useEffect(() => {
        if (comparisonState.GetComparisonResponsestatus === 'successfully') {
            setShowContent(true)
            let alienatedString = ''
            let insertedString = ''
            if (comparisonState.GetComparisonResponse && comparisonState.GetComparisonResponse.alienatedStructureComparisons) {
                comparisonState.GetComparisonResponse.alienatedStructureComparisons.map((alienatedStructure) =>
                    alienatedString = alienatedString + alienatedStructure.sheet+"-"+alienatedStructure.parcel+ "; "
                )
                dispatch(setSaveStatusStruttureAlienate(alienatedString))
            }
            if (comparisonState.GetComparisonResponse && comparisonState.GetComparisonResponse.insertedStructureComparisons) {
                comparisonState.GetComparisonResponse.insertedStructureComparisons.map((insertedStructure) =>
                    insertedString = insertedString + " " + insertedStructure.sheet + "-" + insertedStructure.parcel + ";"
                )
                dispatch(setSaveStatusStruttureInserite(insertedString))
            }


            dispatch(resetGetCompareStatus())
        }
    }, [comparisonState.GetComparisonResponsestatus])

    const options: OptionType[] = notificationState.getAllNotificationResponse?.data
        ?.filter((notification) => notification.id !== selectedNot)
        .map((notification) => ({
            value: notification.id,
            label: notification.identifier,
        })) ?? [];

    if (comparisonState.GetComparisonResponsestatus === 'loading') {
        return (
            <LogoSpinnerComponent fullScreen />
        )
    }

    return (
        <div style={{ padding: '24px', paddingBottom: '54px' }}>
            <div style={{ display: 'flex', gap: '48px', alignItems: 'center' }}>
                <div style={{ flex: '0.4' }}>
                    <SelectCustom
                        label="Scegli notifica precedente"
                        placeholder={'Scegli notifica precedente'}
                        options={options}
                        onChange={(value) => dispatch(setPrevNotId(value))}
                    />
                </div>
                <div style={{ flex: '0.3', marginTop: '15px' }}>
                    <Button
                        color="orange"
                        variant="solid"
                        iconPosition="left"
                        icon={<TaskSquare color="#fff" size={24} />}
                        size="md"
                        label="Vedi Differenze"
                        onClick={() => { dispatch(GetComparison(comparisonState.filtersComparison)) }}
                    />
                </div>
            </div>
            <div className="mt-6">
                <CustomHorizontalTab
                    selectedIndex={selectedTab}
                    onTabClick={(index) => setSelectedTab(index)}
                >
                    <div>Vegetale</div>
                    <div>Zootecnia</div>
                    <div>Preparazione</div>
                </CustomHorizontalTab>
                {
                    showContent && (
                        <div className="fieldset bg-brandPrimary-200">
                            {
                                selectedTab === 0 &&
                                <ComparazioneVegetale />
                            }
                            {
                                selectedTab === 1 &&
                                <ComparazioneZootecnia />
                            }
                            {
                                selectedTab === 2 &&
                                <ComparazionePreparazione />
                            }
                        </div>
                    )
                }
            </div>

        </div>
    )
}